import script from "./OnDemandCard.vue?vue&type=script&setup=true&lang=js"
export * from "./OnDemandCard.vue?vue&type=script&setup=true&lang=js"

import "./OnDemandCard.vue?vue&type=style&index=0&id=5dcaaec2&lang=scss&scoped=true"

import exportComponent from "c:\\DevOpsProdCore2_02\\_work\\151\\s\\ford-digital-fleet-hub-fe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dcaaec2"]])

export default __exports__